const routes = [
    {
        path: "/reservations",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'reservation_index'
        },
        component_full_path: 'reservation/pages/Index'
    }
];

export default routes;
